import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/SEO';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: 'Anime HOT or NOT',
        description: 'Rate your favorite anime characters from 1 to 10 and discover the hottest anime characters. Join our community of anime fans.',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${siteUrl}/rate?q={search_term_string}`
          },
          'query-input': 'required name=search_term_string'
        }
      },
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'Anime HOT or NOT',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        },
        sameAs: []
      },
      {
        '@type': 'WebPage',
        '@id': `${siteUrl}/#webpage`,
        url: siteUrl,
        name: 'Anime HOT or NOT - Rate Your Favorite Anime Characters',
        isPartOf: { '@id': `${siteUrl}/#website` },
        about: { '@id': `${siteUrl}/#organization` },
        description: 'Rate your favorite anime characters from 1 to 10 and discover the hottest anime characters. Join our community of anime fans and share your opinions on the best anime characters.'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Anime HOT or NOT - Rate Your Favorite Anime Characters"
        description="Rate your favorite anime characters from 1 to 10 and discover the hottest anime characters. Join our community of anime fans and share your opinions on the best anime characters."
        keywords="anime, anime characters, hot or not, anime rating, character rating, anime community, rate anime, anime fans, best anime characters"
        canonical={siteUrl}
        ogType="website"
        jsonLd={jsonLd}
      />
      
      <Navbar />

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://public.readdy.ai/ai/img_res/8bf178240bb53c7f2b39821527f4f2bc.jpg)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto w-full">
          <div className="flex justify-center mb-6">
            <img 
              src="https://static.readdy.ai/image/cd80e8551adaa83aa4e45d1e4f56c590/f41128b12692ca52858c5e3a8248b8bb.png" 
              alt="Anime HOT or NOT - Rate Your Favorite Anime Characters Logo" 
              className="w-64 h-64 object-contain drop-shadow-2xl"
            />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 drop-shadow-lg">
            Anime<br />HOT or NOT
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 drop-shadow-md">
            Rate your favorite anime characters from 1 to 10 and discover who's the hottest!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/rate"
              className="px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-pink-500 to-purple-600 rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap"
            >
              Start Rating Now
            </Link>
            <Link
              to="/top10"
              className="px-8 py-4 text-lg font-semibold text-gray-900 bg-white rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap"
            >
              View Top 10
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-pink-500 to-purple-600 rounded-full mb-6">
                <i className="ri-user-add-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">Sign Up</h3>
              <p className="text-sm text-gray-600">
                Create your account to start rating anime characters and join our community of anime fans.
              </p>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-pink-500 to-purple-600 rounded-full mb-6">
                <i className="ri-heart-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">Rate Characters</h3>
              <p className="text-sm text-gray-600">
                Rate anime characters from 1 to 10 based on how hot you think they are. Skip if you're not sure!
              </p>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-pink-500 to-purple-600 rounded-full mb-6">
                <i className="ri-trophy-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">See Rankings</h3>
              <p className="text-sm text-gray-600">
                Check out the top 10 hottest anime characters and see where your favorites rank!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-pink-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
            Features
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-lg mb-4">
                <i className="ri-filter-3-line text-2xl text-pink-500"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Filter by Gender</h3>
              <p className="text-sm text-gray-600">
                Choose to rate boys only, girls only, or all characters.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-chat-3-line text-2xl text-purple-500"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Comment System</h3>
              <p className="text-sm text-gray-600">
                Leave comments and reply to others on character pages.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-lg mb-4">
                <i className="ri-heart-line text-2xl text-pink-500"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Favorite Characters</h3>
              <p className="text-sm text-gray-600">
                Add up to 5 favorite characters to your profile.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-user-star-line text-2xl text-purple-500"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Custom Avatar</h3>
              <p className="text-sm text-gray-600">
                Use any character as your profile avatar with zoom control.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
            Ready to Start Rating?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Join thousands of anime fans rating their favorite characters. Discover the hottest anime characters and share your opinions!
          </p>
          <Link
            to="/rate"
            className="inline-block px-10 py-4 text-lg font-semibold text-white bg-gradient-to-r from-pink-500 to-purple-600 rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap"
          >
            Get Started
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
